/* istanbul ignore file */
import {
  ErrorMonitoring,
  ErrorMonitoringServiceInterface,
  ExclusiveEventHintOrCaptureContext,
} from './ErrorMonitoring';

const noop = {
  setTag: () => null,
  setTags: () => null,
  captureException: () => null,
} as unknown as ErrorMonitoringServiceInterface;

export class ErrorMonitoringClientService implements ErrorMonitoring {
  private sentryInstance?: ErrorMonitoringServiceInterface;

  private async getInstance(): Promise<ErrorMonitoringServiceInterface> {
    if (!this.sentryInstance) {
      try {
        this.sentryInstance = await import('@sentry/nextjs');
      } catch {
        this.sentryInstance = noop;
      }
    }

    return this.sentryInstance;
  }

  async addCustomTag(key: string, value: string) {
    const instance = await this.getInstance();
    instance.setTag(key, value);
  }

  async addCustomTags(tags: Record<string, string>) {
    const instance = await this.getInstance();
    instance.setTags(tags);
  }

  async captureError(error: unknown, hint?: ExclusiveEventHintOrCaptureContext) {
    const instance = await this.getInstance();
    instance.captureException(error, hint);
  }

  async identify(id: string) {
    await this.addCustomTag('device_id', id);
  }
}
